import { Module } from 'vuex'
import {
  User,
  Store
} from '@/types'
import apiFactory from '@api/contacts'

const api = apiFactory()

const storeModule: Module<User.UserContactsState, Store.RootState> = {
  namespaced: true,
  state: {
    assignees: [],
    educationTeam: []
  },
  mutations: {
    SET_ASSIGNEES: (state, assignees: User.API.ReqRes.UserContacts.Assignee[]) => {
      state.assignees = assignees
    },
    SET_EDUCATION_TEAM: (state, educationTeam: User.API.ReqRes.UserContacts.EducationTeam[]) => {
      state.educationTeam = educationTeam
    }
  },
  actions: {
    async getAllContacts ({ dispatch }) {
      await Promise.all([dispatch('getAssignees'), dispatch('getEducationTeam')])
    },
    async getAssignees ({ commit }) {
      commit('SET_ASSIGNEES', [])
      commit('SET_ASSIGNEES', await api.getAssignees())
    },
    async getEducationTeam ({ commit }) {
      commit('SET_EDUCATION_TEAM', [])
      commit('SET_EDUCATION_TEAM', [await api.getEducationTeam()])
    }
  },
  getters: {
    assignees: state => state.assignees,
    educationTeam: state => state.educationTeam
  }
}

export default storeModule
